import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_emnha4uv86: FaireBrandEntity = {
  token: "b_emnha4uv86",
  type: "brand",
  name: "So Me",
  avatarUrl:
    "https://cdn.faire.com/fastly/e1083bde4b98cdcbed9127cf1bd6f003d16186540a76d31cbb6d16777778ff15.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/28355a6d55f3cf215b258992adf5937fc5e94c9ab3ecc8c591f98612b88a514a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e1083bde4b98cdcbed9127cf1bd6f003d16186540a76d31cbb6d16777778ff15.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/28355a6d55f3cf215b258992adf5937fc5e94c9ab3ecc8c591f98612b88a514a.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 42,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to So Me, where fashion and versatility meet for the modern woman. We are a forward-thinking brand committed to empowering women through stylish, contemporary clothing that effortlessly transitions from day to night. Our collections are more than just outfits; they are an expression of your unique style, effortlessly chic, and confidently individual.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:05.418Z",
    importedBy: "entity-db-cli",
  },
};
